import { USER_DETAIL, USER_ROLES, ROLE_MODULES } from "./constants";

export interface IUserRole {
  Module: string;
}

export const getUserRoles = (): IUserRole[] => {
  const readRoles = (key: string, path?: string): IUserRole[] => {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      const roles = path ? parsed?.[path] : parsed;
      return Array.isArray(roles) ? roles : [];
    } catch {
      return [];
    }
  };

  const roles = readRoles(USER_ROLES);
  return roles.length > 0 ? roles : readRoles(USER_DETAIL, "Roles");
};

export const setUserRoles = (roles: unknown): void => {
  if (Array.isArray(roles)) {
    localStorage.setItem(USER_ROLES, JSON.stringify(roles));
  }
};

export const checkUserRoles = (roleList: string | string[]): boolean => {
  const required = typeof roleList === "string" ? [roleList] : roleList;
  if (!required || required.length === 0) return false;

  const userRoles = getUserRoles();
  if (userRoles.length === 0) return false;

  return required.every((role) => userRoles.some((userRole) => userRole?.Module === role));
};
